import { typography, FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    container: {
      fontFamily: FONT_FAMILY,
      position: 'relative',
      border: 0,
      backgroundColor: colors.lighterSmoke,
      minHeight: 100,
      padding: '28px 0',
      boxShadow: 'none'
    },
    header: {
      color: colors.approxBlack
    },
    content: {
      ...typography.fontLight,
      color: colors.approxBlack,
      border: 0,
      maxWidth: 665
    },
    button: {
      background: colors.primary,
      textTransform: 'uppercase',
      color: colors.white,
      borderRadius: 25
    }
  }
  return styles
}

export default themeStyles

